import { ArrowOutward } from "@mui/icons-material";
import { makeStyles } from "components/providers/makeStyles";

const useStyle = makeStyles(theme => ({
    wrapper: {
        display: "inline-flex",
        alignItems: "baseline",
        cursor: "pointer",
        paddingTop: theme.spacing(1),
        color: theme.palette.text.secondary,
        fontSize: theme.typography.body2.fontSize,
    },
    location:{
        verticalAlign: "text-bottom",
    },
    arrow: {
        verticalAlign: "text-top",
        fontSize: theme.typography.body1.fontSize,
        marginLeft: theme.spacing(0.5),
    }
}));

export const EventLocation = ({ location }) => {
    const classes = useStyle();

    if (!location) {
        return null;
    }

    return (
        <a className={classes.wrapper} href={location.googleMapsUri} target="_blank" rel="noopener noreferrer">
            <span role="img" aria-label="location pin">📍</span>
            <div className={classes.location}>
                {location.placePredictionText}
                <ArrowOutward className={classes.arrow} />
            </div>
        </a>
    );
};
